import React, { useState, useEffect } from 'react';
import TwoCards from 'components/Card/TwoCards';
import AddForm from './AddForm';
import CustomSkeleton from '../../../../../components/OtherElements/CustomSkeleton';
import SlidersTable from './SlidersTable';
import API from '../../../../../api/axios';
import MainContext from '../../../../../store/MainContext';
import { deviceList } from '../../../../../components/FormInputs/SelectDevices';
import { userTypesList } from '../../../../../components/FormInputs/SelectUserTypes';
import SlidesDialog from './SlidesDialog';

const AddSlider = (props) => {
  const [sliders, setSliders] = useState(null);
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [edit, setEdit] = useState(false);
  const [sliderId, setSliderId] = useState(null);
  const main = React.useContext(MainContext);
  const { itemsCountPerPage } = main.state.Props;
  const loadSliders = async (page = 1) => {
    try {
      const { data } = await API.get(
        `/api/v1/admin/slider/list/${page}/${itemsCountPerPage}`
      );
      !!data && setSliders(data);
    } catch (error) {
      console.error(error);
    }
  };
  const handlePageChange = (page) => {
    loadSliders(page);
  };
  const handleDeleteSlider = async (id) => {
    try {
      const response = await API.delete(`/api/v1/admin/slider/${id}`);
      loadSliders();
      props.showMessage(1, '', '', 'اسلایدر حذف گردید');
    } catch (error) {
      props.showMessage(2, '', '', 'بروز خطا');
      console.error(JSON.stringify(error, null, 2));
    }
  };
  const handleToEditSlider = (id) => {
    let sliders2 = JSON.parse(JSON.stringify(sliders));
    let slider = sliders2.docs.find((s) => s._id === id);
    let devices = deviceList.filter((device) =>
      slider.devices.includes(device.value)
    );
    let users = userTypesList.filter((user) =>
      slider.users.includes(user.value)
    );
    slider['devices'] = devices;
    slider['users'] = users;
    setEdit(slider);
  };
  const handleCancelEdit = () => {
    setEdit(false);
  };
  const handleOpenDialog = async (id) => {
    setSliderId(id);
    setSlides(sliders.docs.find((slider) => slider._id === id).slides);
    setOpen(true);
  };
  const handleDeleteSlide = (slideId) => {
    const newSlides = slides.filter((slide) => slide._id !== slideId);
    setSlides([...newSlides]);
  };
  const handleUploadAndSaveSlides = () => {
    setOpen(false);
  };
  const handleCancelUpload = () => {
    setSlides(null);
    setOpen(false);
  };

  useEffect(() => {
    loadSliders();
  }, [open]);

  return (
    <TwoCards
      title={props.config.name}
      category="افزودن، ویرایش و حذف اسلایدر جهت دیوایس های مختلف"
      secondaryTitle={!!edit ? 'ویرایش' : 'افزودن'}
      secondaryContent={
        <AddForm
          onSubmit={loadSliders}
          showMessage={props.showMessage}
          edit={edit}
          onCancelEdit={handleCancelEdit}
        />
      }
      secondaryCategory={
        !!edit ? 'جهت ویرایش اسلایدر' : 'جهت افزودن اسلایدر جدید'
      }
    >
      {open && (
        <SlidesDialog
          open={open}
          onClose={handleCancelUpload}
          onSave={handleUploadAndSaveSlides}
          showMessage={props.showMessage}
          sliderId={sliderId}
          slides={slides}
          onDeleteSlide={handleDeleteSlide}
        />
      )}
      {!!sliders ? (
        <SlidersTable
          onAddSlidesClick={handleOpenDialog}
          sliders={sliders}
          onDelete={handleDeleteSlider}
          onPageChange={handlePageChange}
          onEdit={handleToEditSlider}
        />
      ) : (
        <CustomSkeleton count={itemsCountPerPage} />
      )}
    </TwoCards>
  );
};

export default AddSlider;
